<template>
  <div class="myCenter editUserInfo modelPage formStyle">
    <van-nav-bar left-arrow :left-text="navTitle" @click-left="onClickLeft">
    </van-nav-bar>
    <div class="editUserInfoContent">
      <div
        class="userContent"
        v-if="$route.query.type == 'name' || $route.query.type == 'company'"
      >
        <div v-if="$route.query.type == 'name'">
          <div class="title">ユーザー名</div>
          <van-field
            class="fontStyle"
            v-model="form.nickname"
            maxlength="24"
            placeholder="ユーザー名を入力してください"
          />
        </div>
        <div v-if="$route.query.type == 'company'">
          <div class="title">会社名</div>
          <van-field
            class="fontStyle"
            v-model="form.companyName"
            maxlength="24"
            placeholder="会社名を入力してください"
          />
        </div>
        <div class="tips">
          2~24文字以内に入力してください。特殊文字の使用は避けてください
        </div>
      </div>

      <div class="loginForm mtop10" v-else style="margin-top: 0;">
        <van-form
          class="loginFormBox"
          v-if="$route.query.type == 'email' && !newBox"
        >
          <div>古いメールアドレス</div>
          <van-field
            class="fontStyle"
            @change="changInput"
            v-model="form.mailbox"
            :disabled="true"
            placeholder="古いメールアドレスを入力してください"
          />

          <div class="button">
            <van-button
              :loading="loadingCode"
              class="sendCode buttonBlue"
              v-show="Verification"
              @click="sendCode"
              type="info"
            >
            認証コードを取得</van-button
            >
            <div class="sendCodeTimer buttonBlue" v-show="!Verification">
              <span>{{ timer }}</span
              >S
            </div>
          </div>
          <div style="margin-top: 6px;">認証コード</div>
          <div class="getCode">
            <van-field
              class="fontStyle"
              @input="changInput"
              v-model="form.code"
              maxlength="4"
              placeholder="コードを入力"
            />
          </div>
        </van-form>
        <van-form
          class="loginFormBox"
          v-if="$route.query.type == 'email' && newBox"
        >
          <div>新しいメールアドレス</div>
          <van-field
            class="fontStyle"
            @change="changInput2"
            v-model="form.newEmail"
            placeholder="新しいメールアドレスを入力してください"
          />

          <div class="button">
              <div
                class="sendCode buttonBlue"
                v-show="Verification"
                @click="sendCode"
              >
              認証コードを取得
              </div>
              <div class="sendCodeTimer buttonBlue" v-show="!Verification">
                <span>{{ timer }}</span
                >S
              </div>
            </div>
          <div style="margin-top: 6px;">認証コード</div>
          <div class="getCode">
            <van-field
              class="fontStyle"
              @input="changInput2"
              v-model="form.code"
              maxlength="4"
              placeholder="コードを入力"
            />
          </div>
        </van-form>
      </div>
      <van-button
        v-if="$route.query.type == 'name'"
        round
        block
        type="info"
        native-type="submit"
        class="buttonBlue userButton"
        :loading="loading"
        @click="saveUserName()"
        >保存</van-button
      >
      <van-button
        v-if="$route.query.type == 'company'"
        round
        block
        type="info"
        native-type="submit"
        class="buttonBlue userButton"
        :loading="loading"
        @click="saveCompanyName()"
        >保存</van-button
      ><van-button
        v-if="$route.query.type == 'email'"
        round
        block
        :disabled="disabled"
        type="info"
        native-type="submit"
        class="buttonBlue userButton"
        @click="saveUserEmail()"
        >{{ emialBtnText }}</van-button
      >
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { Toast } from "vant";

Vue.use(Toast);
import {
  userInfo,
  updateNickname,
  updateCompanyName,
  sendEmailCode,
  checkEmailCode,
  updateEmail
} from "@/http/user";
export default {
  data() {
    return {
      navTitle: this.$route.query.title,
      form: {
        nickname: "",
        id: "",
        mailbox: "",
        companyName: "",
        code: ""
      },

      checked: false,
      timer: 300, // 定义初始时间为60s
      Verification: true, // 通过v-show控制显示获取还是倒计时
      resendCode: false,
      disabled: true,
      emialBtnText: "次のステップ",
      loading: false,
      loadingCode: false,
      newBox: false
    };
  },
  mounted() {
    this.getUserInfo();
  },
  methods: {
    getUserInfo() {
      userInfo().then(res => {
        let { data, code } = res.data;
        if (code == 200) {
          this.form = data;
        }
      });
    },
    onClickLeft() {
      this.$router.back(1);
    },
    sendCode() {
      if (!this.newBox) {
        //校验旧邮箱验证码
        if (!this.form.mailbox || this.form.mailbox == "") {
          Toast({
            type: "fail",
            icon: "cross",
            // duration: 0,
            message: "メールアドレスを入力してください"
          });
          return;
        }
        let email = /^[a-zA-Z0-9_.,*/;':<>~`#$%^&()=+-]+@[a-zA-Z0-9_-]+(.[a-zA-Z0-9_-]+)+$/;
        if (!email.test(this.form.mailbox)) {
          Toast({
            type: "fail",
            icon: "cross",
            // duration: 0,
            message: "正しいメールアドレスを入力してください"
          });
          return;
        }

        var params = {
          mailbox: this.form.mailbox,
          type: 2
        };
      } else {
        if (!this.form.newEmail || this.form.newEmail == "") {
          Toast({
            type: "fail",
            icon: "cross",
            // duration: 0,
            message: "メールアドレスを入力してください"
          });
          return;
        }
        let email = /^[a-zA-Z0-9_.,*/;':<>~`#$%^&()=+-]+@[a-zA-Z0-9_-]+(.[a-zA-Z0-9_-]+)+$/;
        if (!email.test(this.form.newEmail)) {
          Toast({
            type: "fail",
            icon: "cross",
            // duration: 0,
            message: "正しいメールアドレスを入力してください"
          });
          return;
        }
        var params = {
          mailbox: this.form.newEmail,
          type: 2
        };
      }
      this.loadingCode = true;
      sendEmailCode(params).then(res => {
        let { data, code } = res.data;
        if (code == 200) {
          this.loadingCode = false;
          Toast({
            type: "success",
            // duration: 0,
            message: "メールに認証コードを送信しました。"
          });
          this.clearInterval();
        } else {
          Toast({
            type: "fail",
            icon: "cross",
            message: res.data.msg
          });
          this.loadingCode = false;
        }
      });
    },
    clearInterval() {
      this.Verification = false; // 点击button改变v-show的状态
      let authTimer = setInterval(() => {
        // 定时器设置每秒递减
        this.timer--; // 递减时间
        if (this.timer <= 0) {
          this.Verification = true; // 60s时间结束还原v-show状态并清除定时器
          this.resendCode = true;
          clearInterval(authTimer);
        }
      }, 1000);
      this.timer = 299;
    },
    changInput() {
      if (this.form.mailbox != "" && this.form.code.length == 4) {
        this.disabled = false;
      }
    },
    changInput2() {
      if (this.form.newBox != "" && this.form.code.length == 4) {
        this.disabled = false;
      }
    },
    saveUserName() {
      if (this.form.nickname == "") {
        Toast({
          type: "fail",
          icon: "cross",
          message: "ユーザー名を入力してください"
        });
        return;
      }
      let pattern = /[~!@#$%^&*<>|￥']/gi;
      let name = this.form.nickname;
      if (pattern.test(name) || name.length < 2) {
        Toast({
          type: "fail",
          icon: "cross",
          message:
            "2~24文字以内に入力してください。特殊文字の使用は避けてください"
        });
        return;
      }
      this.loading = true;
      updateNickname(this.form.nickname).then(res => {
        let { data, code } = res.data;
        if (code == 200) {
          Toast({
            type: "success",
            message: "変更しました"
          });
          this.loading = false;
          setTimeout(() => {
            this.$router.push({ path: `/myCenter` });
          }, 1000);
        }
      });
    },
    saveCompanyName() {
      if (this.form.companyName == "") {
        Toast({
          type: "fail",
          icon: "cross",
          message: "会社名を入力してください"
        });
        return;
      }
      let pattern = /[~!@#$%^&*<>|￥']/gi;
      let name = this.form.companyName;
      if (pattern.test(name) || name.length < 2) {
        Toast({
          type: "fail",
          icon: "cross",
          message:
            "2~24文字以内に入力してください。特殊文字の使用は避けてください"
        });
        return;
      }
      this.loading = true;
      updateCompanyName(this.form.companyName).then(res => {
        let { data, code } = res.data;
        if (code == 200) {
          Toast({
            type: "success",
            message: "変更しました"
          });
          this.loading = false;
          setTimeout(() => {
            this.$router.push({ path: `/myCenter` });
          }, 1000);
        }
      });
    },
    saveUserEmail() {
      if (!this.newBox) {
        this.loading = true;
        //校验旧邮箱验证码
        let params = {
          email: this.form.mailbox,
          code: this.form.code
        };
        checkEmailCode(
          "?email=" + this.form.mailbox + "&code=" + this.form.code
        ).then(res => {
          let { data, code } = res.data;
          if (code == 200) {
            Toast({
              type: "success",
              message: "確認しました"
            });
            //旧的校验成功后
            this.emialBtnText = "確認";
            this.newBox = true;
            this.form.code = "";
            this.loading = false;
            this.Verification = true;
          } else {
            Toast({
              type: "fail",
              icon: "cross",
              message: res.data.msg
            });
            this.loading = false;
          }
        });
      } else {
        this.loading = true;
        let params = {
          email: this.form.newEmail,
          code: this.form.code
        };
        updateEmail(
          "?email=" + this.form.newEmail + "&code=" + this.form.code
        ).then(res => {
          let { data, code } = res.data;
          if (code == 200) {
            Toast({
              type: "success",
              message: "変更しました"
            });
            this.loading = false;
            localStorage.removeItem("token");
            setTimeout(() => {
              this.$router.push({ path: `/login` });
            }, 1000);
          } else {
            Toast({
              type: "fail",
              icon: "cross",
              message: res.data.msg
            });
            this.loading = false;
          }
        });
      }
    }
  }
};
</script>

<style src="@/assets/css/mycenter.css" scoped></style>
<style src="@/assets/css/form.css" scoped></style>
<style>
.editUserInfoContent {
  height: calc(100% - 160px);
  overflow-y: scroll;
  overflow-x: hidden;
}
.aiCenter .myCenter.editUserInfo .van-nav-bar__left .van-nav-bar__text {
  font-family: MediumFont;
  font-size: 18px !important;
}
.editUserInfo .userContent {
  height: calc(100% - 160px);
  margin: 0 24px 24px 24px;
  font-family: MediumFont;
  font-size: 16px;
}
.editUserInfo .userContent .van-cell {
  border-radius: 60px;
  padding: 0 16px;
  height: 48px;
  line-height: 48px;
  font-size: 14px;
  margin: 8px 0 16px 0;
}
.editUserInfo .userContent .tips {
  font-family: RegularFont;
  font-size: 14px;
  font-weight: normal;
  line-height: 22px;
  color: rgb(35, 32, 54, 0.5);
}
.editUserInfo.formStyle .buttonBlue {
  font-family: RegularFont !important;
}
.fontStyle input {
  font-size: 14px;
  font-family: RegularFont;
}
.fontStyle input::input-placeholder {
  font-size: 14px;
  color: rgb(35, 32, 54, 0.3);
  font-family: RegularFont;
}
.fontStyle input::-webkit-input-placeholder {
  font-size: 14px;
  color: rgb(35, 32, 54, 0.3);
  font-family: RegularFont;
}
.fontStyle input::-moz-placeholder {
  font-size: 14px;
  color: rgb(35, 32, 54, 0.3);
  font-family: RegularFont;
}
.fontStyle input::-moz-placeholder {
  font-size: 14px;
  color: rgb(35, 32, 54, 0.3);
  font-family: RegularFont;
}
.fontStyle input::-ms-input-placeholder {
  font-size: 14px;
  color: rgb(35, 32, 54, 0.3);
  font-family: RegularFont;
}

.editUserInfo.formStyle .button {
  margin-bottom: 12px;
}
.editUserInfo.formStyle .loginForm .buttonBlue{
  margin: 0;
  width: 100%;
  text-align: center;
}
@media screen and (min-width: 1439px) {
  .editUserInfo .userContent {
    height: calc(100% - 160px); /* no*/
    margin: 0 24px 24px 24px; /* no*/
    font-size: 16px; /* no*/
  }
  .editUserInfo .userContent .van-cell {
    border-radius: 60px; /* no*/
    padding: 0 16px; /* no*/
    height: 48px; /* no*/
    line-height: 48px; /* no*/
    font-size: 14px; /* no*/
    margin: 8px 0 16px 0; /* no*/
  }
  .editUserInfo .userContent .tips {
    font-size: 14px; /* no*/
    line-height: 22px; /* no*/
  }
  .fontStyle input {
    font-size: 14px; /* no*/
  }
  .fontStyle input::input-placeholder {
    font-size: 14px; /* no*/
  }
  .fontStyle input::-webkit-input-placeholder {
    font-size: 14px; /* no*/
  }
  .fontStyle input::-moz-placeholder {
    font-size: 14px; /* no*/
  }
  .fontStyle input::-moz-placeholder {
    font-size: 14px; /* no*/
  }
  .fontStyle input::-ms-input-placeholder {
    font-size: 14px; /* no*/
  }
  .aiCenter .myCenter.editUserInfo .van-nav-bar__left .van-nav-bar__text {
    font-size: 18px !important; /* no*/
  }
  .editUserInfo.formStyle .button {
    margin-bottom: 12px; /* no*/
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/myCenter/editUserInfo.vue